import { render, staticRenderFns } from "./checkbox.html?vue&type=template&id=451934f9&scoped=true&"
import script from "./checkbox.js?vue&type=script&lang=js&"
export * from "./checkbox.js?vue&type=script&lang=js&"
import style0 from "./checkbox.scss?vue&type=style&index=0&id=451934f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451934f9",
  null
  
)

export default component.exports